import React, { Fragment } from "react";

function AboutPage() {

    return (
        <Fragment>
<div className="about_space">
<h1 id="habout">About</h1>
<section className="aboutsect"> 
    
    <h3>Welcome to DIY Heritage! </h3>
    <p>This is an experimental project where you'll find a collection of materials I have preserved, and (hopefully) inspiration for those seeking to safeguard their own unique heritage.</p> 
</section> 
<section className="aboutsect"> 
    <h3>What Heritage?</h3> 
    <p>Heritage isn’t limited to artefacts and monuments approved by galleries, libraries, archives, and museums. It also includes:</p> 
    <ul> 
        <li><b>Stories and lessons</b> passed down through generations.</li> 
        <li><b>Places and objects</b> that carry personal or communal meaning.</li> 
        <li><b>Memories and feelings</b> that shape your identity.</li> 
    </ul> 
    <p>These elements may not be recognized by authorities, but they are not less valuable.</p> 
</section> 
<section className="aboutsect"> 
    <h3>Why DIY?</h3> 
    <p>Personal heritage often goes unnoticed or unappreciated. While no authority can dictate what is valuable enough to be preserved for the future, they also won’t help you safeguard it unless they see value in it themselves. That’s why, as with many things in life, you need to take action and 'do it yourself'.</p> 
    <p>With this realization, I decided to take action and began to preserve the heritage that I find meaningful:</p> 
    <ul> 
        <li><b>Street art</b> that might disappear overnight, offering a valuable source for history from below.</li>
        <li><b>Memories </b>and my family archive that define me and my roots.</li> 
        <li><b>DIY projects</b> that reflect the learning process, filled with failures and the occasional small victory.</li> 
    </ul>
    <p>On this platform, I am sharing a curated selection of my collections with the world.</p> 
</section> 
<section className="aboutsect"> 
    <h3>Explore and Connect</h3> 
    <p>DIY Heritage is divided into three main categories: <a href="/project/1">street art</a>, <a href="/project/2">memories</a>, and <a href="project/3">DIY projects</a>. You can explore the collection by visiting each project page or using <a href="/archive">the archive page</a> to view all items and apply filters. 
    Additionally, you can explore items on the interactive map by visiting <a href="/map">the map page</a>.</p> 
    <p>I hope this site inspires you to think about your own heritage. Feel free to explore, reflect, and even share your own story <a href="mailto:contact.diyheritage@gmail.com">with me!</a></p> 
</section> 
 </div>
            
        </Fragment>
  );
}
export default AboutPage;